<template>
  <div class="portal-analytics-tire-select">
    <select
      :id="selectId"
      class="portal-analytics-tire-select__control form-select"
      :value="modelValue"
      :aria-label="$t('portalHome.analytics.tireType')"
      @change="onChange"
    >
      <option v-for="type in tireTypes" :key="type.id" :value="type.id">
        {{ optionLabel(type) }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";
import { useI18n } from "vue-i18n";
import { portalAnalyticsTireTypes } from "@/data/portal_analytics_mock";

defineProps({
  modelValue: { type: String, default: "all" },
  selectId: { type: String, required: true },
});

const emit = defineEmits(["update:modelValue"]);
const { t } = useI18n();

const tireTypes = portalAnalyticsTireTypes;

const optionLabel = (type) =>
  type.id === "all" ? t("portalHome.analytics.tireType") : t(type.labelKey);

const onChange = (event) => {
  emit("update:modelValue", event.target.value);
};
</script>

<style scoped lang="scss">
@import "@/styles/portal-home/portal-analytics-tire-select";
</style>
